import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { syncAuthState } from "../../services/authorization/thunks";

const useAuthenticationSync = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(syncAuthState());
  }, [dispatch]);
}; 

export default useAuthenticationSync;
